export default __webpack_public_path__ + "static/media/enConstruccionLista.a0f8b5dc.svg";